$(window).on('load', function() {

  var $workList = $('.work-list');

  if ($workList.length) {
    $workList.isotope({
      itemSelector: 'li'
    });
  }

  $('.category-list > .category > .btn').on( 'click', function(e) {
  e.preventDefault();
  var filterValue = $(this).attr('data-filter');
  $workList.isotope({ filter: filterValue });
  });

  $('.mh_content').matchHeight();

  $('.mh_li').matchHeight({
  byRow: false
  });

  $('#nav-toggle').on('click', function(event) {
    event.preventDefault();
    $('.sticky-nav').toggleClass('menu-open');
    $('#mobile-toggle').toggleClass('active');
    $('body, html').removeClass('no-scroll');
  });

  $('#mobile-toggle').on('click', function(e) {
    e.preventDefault();


    if ( $('.sticky-nav').hasClass('menu-open') ) {
      $('.sticky-nav').removeClass('menu-open');
    } else {
      $('.sticky-nav').addClass('menu-open');
    }

    if ( $('body, html').hasClass('no-scroll') ) {
      $('body, html').removeClass('no-scroll');
    } else {
      $('body, html').addClass('no-scroll');
    }

    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');
    }

  });

  var wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 150,
    mobile: true,
    live: true,
    scrollContainer: null
  });

  wow.init();

  $('.button--scrollTop').on('click', function(e) {
  e.preventDefault();
  $("html, body").animate({ scrollTop: 0 }, "fast");
  });

  $('h1:has(span), h2:has(span), h3:has(span)').addClass('has-line');

  $('.has-line').each(function(){
      var line = $('.line-ani');
      var word = $(this).children('span');

      line.clone().appendTo(word);
  })

  var els = document.getElementsByClassName("line-vivus");
    for (var i = els.length - 1; i >= 0; i--) {
    new Vivus(els[i], {
      type: 'scenario',
      duration: 25,
    });
  }

  $('.clients-list').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    rows: 3
  });

});

// //update the width value when the browser is resized (useful for devices which switch from portrait to landscape)
$(window).resize(function(){
  var current_width = $(window).width();
  //do something with the width value here!
  if(current_width <= 768){
  console.log('resize');
  if ( $('#mobile-toggle').hasClass('active') ) {
    $('body, html').addClass('no-scroll').scrollTop(0);
  }
  }

  if(current_width >= 768){
  $('body, html').removeClass('no-scroll')
  }

});

